<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
  >
    <path d="M5.5 5L0.5 0L0.5 10L5.5 5Z" />
  </svg>
</template>
